export var AppCreationScreens;
(function (AppCreationScreens) {
    AppCreationScreens["SELECT_TYPE"] = "SELECT_TYPE";
    AppCreationScreens["SET_NAME_AND_ICON"] = "SET_NAME_AND_ICON";
    AppCreationScreens["SET_GLOBAL_STYLES_COLOR"] = "SET_GLOBAL_STYLES_COLOR";
    AppCreationScreens["SET_GLOBAL_STYLES_TEXT"] = "SET_GLOBAL_STYLES_TEXT";
    AppCreationScreens["SET_CREATING_APP"] = "SET_CREATING_APP";
    AppCreationScreens["EXPLORE_TEMPLATES"] = "EXPLORE_TEMPLATES";
    AppCreationScreens["SET_ENVIRONMENT_VARIABLES"] = "SET_ENVIRONMENT_VARIABLES";
})(AppCreationScreens || (AppCreationScreens = {}));
export var AppCreationTypes;
(function (AppCreationTypes) {
    AppCreationTypes["SCRATCH"] = "SCRATCH";
    AppCreationTypes["TEMPLATE"] = "TEMPLATE";
})(AppCreationTypes || (AppCreationTypes = {}));
export var AppEditTypes;
(function (AppEditTypes) {
    AppEditTypes["NAME"] = "NAME";
    AppEditTypes["LOGO"] = "LOGO";
})(AppEditTypes || (AppEditTypes = {}));
export var AppCreateTypes;
(function (AppCreateTypes) {
    AppCreateTypes["COMPLETE"] = "COMPLETE";
    AppCreateTypes["PRIMARY"] = "PRIMARY";
    AppCreateTypes["ADDITIONAL"] = "ADDITIONAL";
})(AppCreateTypes || (AppCreateTypes = {}));
